import Shepherd from 'shepherd.js';
import store from '../store';

function updateUserShowTour(event) {
  store.dispatch('setMetadata', { 
    shepherd:{
      show: event
    }
  })
    .then(res => {
      if (res.status === 200) {
        store.commit('setUser',{
          ...store.state.user,
          metadata: {
            ...store.state.user.metadata,
            shepherd:{
              show: event
            }
          }});
      } else {
        throw res.data.error;
      }
    })
    .catch(error => {
      console.error(error);
    });
}

const step1Text = '<div class="sh-heading">Stadt/Gemeinde/Landkreis</div> <div class="sh-text">Im ersten Schritt wird die/der zu betrachtende Stadt/Gemeinde/Landkreis ausgewählt. Bitte wählen Sie die/den von Ihnen erstellte/n Stadt/Gemeinde/Landkreis.</div>';
const step2Text = '<div class="sh-heading">Szenario</div> <div class="sh-text">Für jede/n Stadt/Gemeinde/Landkreis können mehrere Szenarien erstellt und berechnet werden. Wählen Sie nun das von Ihnen erstellte Szenario.</div>';

function shepherdTour() {

  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      scrollTo: { behavior: "smooth", block: "center" },
      classes: "quanticy-shepherd-tour",
      when: {
        show() {
          const currentStepElement = tour.currentStep.el;
          const footer = currentStepElement.querySelector(".shepherd-footer");
          const divBox = document.createElement("div");

          divBox.style.display = "flex"
          divBox.style.justifyContent = "space-between"

          const progress = document.createElement("div");
          progress.id = "shepher-progress-dots";

          // for (let index = 0; index < tour.steps.length; index += 1) {
          //   const innerDot = document.createElement("div");
          //   innerDot.id = `${ index }-sh-dot`;
          //   innerDot.style.width = "10px";
          //   innerDot.style.height = "10px";
          //   innerDot.style.background = "#fff";
          //   innerDot.style.borderRadius = "50%";
          //   if (tour.steps.indexOf(tour.currentStep) === index) {
          //     innerDot.style.opacity = "1";
          //   } else {
          //     innerDot.style.opacity = "0.6";
          //   }
          //   innerDot.onclick = function () {
          //     tour.show(index);
          //   };
          //   progress.appendChild(innerDot);
          // }

          const checkboxBox = document.createElement("div");
          checkboxBox.style = "display: flex; align-items: center;"

          const checkbox = document.createElement("input");
          checkbox.type="checkbox"
          checkbox.checked = store.state.user.metadata.shepherd?.show ||
            !Object.prototype.hasOwnProperty.call(
              store.state.user.metadata,
              "shepherd"
            )
          checkbox.role="checkbox"
          checkbox.value="Show Tour"
          checkbox.id="show-tour-checkbox"
          checkbox.onclick = function() { 
            const checked = document.getElementById("show-tour-checkbox").checked;
            updateUserShowTour(checked)

          };
          
          const label = document.createElement("label");
          label.class="v-lable"
          label.style="left: 0px; right: auto; position: relative; color: #fff; margin: 0 10px;" 
          label.innerHTML="Tour jedes mal zeigen"

          checkboxBox.appendChild(checkbox);
          checkboxBox.appendChild(label);

          divBox.appendChild(progress);
          divBox.appendChild(checkboxBox);

          footer.insertBefore(
            divBox,
            currentStepElement.querySelector(".shepherd-button")
          );
        }
      }
    }
  });

  tour.addStep({
    id: "step-client",
    text:
      '<div class="sh-heading">Herzlich Willkommen bei Quanticy!</div><hr style="margin: 10px 0"><div class="sh-text">Im Folgenden werden die wichtigsten Punkte und Optionen kurz erklärt.</div>',
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }]
    },
    classes: "welcome-shepherd",
    buttons: [
      {
        text: '',
        action: tour.next,
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-chevron-right"></i>',
        action: tour.next,
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  tour.addStep({
    id: "step-set-ags",
    text: step1Text,
    attachTo: {
      element: "#sh-step-1",
      on: "right"
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: tour.back,
        classes: "v-btn--icon"
      },
      {
        text: `<i class="fas fa-chevron-right"></i>`,
        // action: function () {
        //   tour.next();
        // },
        action: tour.next,
        disabled: true,
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });
  
  tour.addStep({
    id: "step-client",
    text: step1Text,
    attachTo: {
      // element: ".v-menu__content",
      element: ".shepherdHelperClass1",
      on: "right"
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: tour.back,
        classes: "v-btn--icon"
      },
      {
        text: `<i class="fas fa-chevron-right"></i>`,
        // action: function () {
        //   tour.next();
        // },
        action: tour.next,
        disabled: true,
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  tour.addStep({
    id: "step-set-update",
    text: step2Text, 
    attachTo: {
      element: "#sh-step-2",
      on: "right"
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: function(){
          store.commit("resetSelectedAgs")
          tour.show("step-set-ags")
        },
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-chevron-right"></i>',
        // action: function () {
        //   window.EventBus.$emit("updateTourUpdateId", "e4ad9fd12d1f425fb45ece0f3e1c66c4");
        //   tour.next();
        // },
        action: tour.next,
        disabled: true,
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  tour.addStep({
    id: "step-client",
    text: step2Text, 
    attachTo: {
      // element: ".v-menu__content",
      element: ".shepherdHelperClass2",
      on: "right"
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: function(){
          store.commit("resetSelectedAgs")
          tour.back()
        },
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-chevron-right"></i>',
        // action: function () {
        //   window.EventBus.$emit("updateTourUpdateId", "e4ad9fd12d1f425fb45ece0f3e1c66c4");
        //   tour.next();
        // },
        action: tour.next,
        disabled: true,
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  tour.addStep({
    id: "step-client-berechnungsparameter-btn",
    text:
      '<div class="sh-heading">Berechnungsparamerter anpassen</div> <div class="sh-text">Sobald ein Szenario ausgewählt ist, können die zugehörigen Parameter angepasst bzw. eingesehen werden. Im nächsten Schritt schauen wir das zugehörige Fenster an.</div>',
    attachTo: {
      element: "#berechnungsparameter-anpassen",
      on: "right"
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: function(){
          store.commit("resetSelectedUpdate")
          tour.show("step-set-update")
        },
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-chevron-right"></i>',
        action: function () {
          document.getElementById("berechnungsparameter-anpassen").click();
        },
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  tour.addStep({
    id: "step-client-berechnungsparameter-dialog",
    text:
      '<div class="sh-heading">Berechnungsparamerter anpassen</div> <div class="sh-text">In dem nun geöffneten Fenster sind alle Daten des Szenarios einsehbar. Diese können, falls notwendig, für die Berechnung noch angepasst werden, wenn das Szenario noch nicht zur Berechnung freigegeben wurde.</div> <div class="sh-text">Nach einer Änderung muss diese gepeichert werden.</div> <div class="sh-text">Falls keine Änderung nötig ist, kann das Fenster rechts oben über das <b>X</b> geschlossen werden.</div>',
    attachTo: {
      element: "body",
      on: "bottom-end"
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [-10, -10] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: function(){
          document.getElementById("close-berechnungsparameter-anpassen-dialog").click();
          tour.back()
        },
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-chevron-right"></i>',
        action: function () {
          document.getElementById("close-berechnungsparameter-anpassen-dialog").click();
          tour.next();
        },
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  // Update is finished
  tour.addStep({
    id: "step-client",
    text:
      '<div class="sh-heading">Ereignisse</div> <div class="sh-text">Die Ergebnisse sind in zwei Kategorien unterteilt, flächenbezogene Größen und standortbasierte Größen.</div>',
    attachTo: {
      element: "#sh-step-3",
      on: "right"
    },
    beforeShowPromise: function() {
      return new Promise(function(resolve) {
        if(store.state.selectedUpdate?.updateStatus === 'calculated'){
          resolve()
        } else {
          tour.next();
        }
      })
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: tour.back,
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-chevron-right"></i>',
        action: function () {
          document.getElementById("sh-click-1").click();
          setTimeout(() => {
            tour.next();
          }, 1);
        },
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  tour.addStep({
    id: "step-client",
    text:
      '<div class="sh-heading">Anzeige der Geo-Koordinaten</div> <div class="sh-text">Die Geo-Koordinaten, die der Berechnung zugrunde liegen, können in einer separaten Liste angezeigt werden.</div>',
    attachTo: {
      element: "#sh-step-4",
      on: "right"
    },
    beforeShowPromise: function() {
      return new Promise(function(resolve) {
        if(store.state.selectedUpdate?.updateStatus === 'calculated'){
          resolve()
        } else {
          tour.next();
        }
      })
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: tour.back,
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-chevron-right"></i>',
        action: function () {
          document.getElementById("sh-click-1").click();
          document.getElementById("sh-click-2").click();
          document.getElementById("sh-click-3").click();
          setTimeout(() => {
            tour.next();
          }, 1);
        },
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  tour.addStep({
    id: "step-client",
    text:
      '<div class="sh-heading">AC und DC</div> <div class="sh-text">Bei allen Ergebnisgrößen in den Flächen- und Punktebenen wird zwischen AC (Wechselstrom) und DC (Gleichstrom) unterschieden.</div>',
    attachTo: {
      element: "#sh-step-3",
      on: "auto"
    },
    beforeShowPromise: function() {
      return new Promise(function(resolve) {
        if(store.state.selectedUpdate?.updateStatus === 'calculated'){
          resolve()
        } else {
          tour.next();
        }
      })
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: tour.back,
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-chevron-right"></i>',
        action: function () {
          tour.next();
        },
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  tour.addStep({
    id: "step-client",
    text:
      '<div class="sh-heading">Zeitstrahl</div> <div class="sh-text">Die Entwicklung des Energiebedarfs über die Jahre kann über den Zeitstrahl betrachtet werden. Jedes Jahr, für das eine Prognose für den Anteil der E-Fahrzeuge vorliegt, kann ausgewählt werden.</div>',
    attachTo: {
      element: "#sh-step-5",
      on: "right"
    },
    beforeShowPromise: function() {
      return new Promise(function(resolve) {
        if(store.state.selectedUpdate?.updateStatus === 'calculated'){
          resolve()
        } else {
          tour.next();
        }
      })
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: tour.back,
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-chevron-right"></i>',
        action: function () {
          tour.next();
        },
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  tour.addStep({
    id: "step-client",
    text:
      '<div class="sh-heading">Hintergrundkarte</div> <div class="sh-text">Der Stil der Hintergrundkarte kann hier angepasst werden.</div>',
    attachTo: {
      element:
        ".ol-unselectable.ol-control.layer-switcher.layer-switcher-group-select-style-children.layer-switcher-activation-mode-mouseover",
      on: "auto"
    },
    beforeShowPromise: function() {
      return new Promise(function(resolve) {
        if(store.state.selectedUpdate?.updateStatus === 'calculated'){
          window.EventBus.$emit("resetSelectedLayers");
          resolve()
        } else {
          tour.next();
        }
      })
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 110] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: tour.back,
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-chevron-right"></i>',
        action: function () {
          document
            .getElementById("abda5e84-f007-4cda-ad1c-c8cbf460e709")
            .click();
          tour.next();
        },
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  tour.addStep({
    id: "step-client",
    text:
      '<div class="sh-heading">Flächenbedarf</div> <div class="sh-text">Ist eine Flächenebene ausgewählt (hier AC Bedarf), wird der  Flächenbedarf standardmäßig in kWh pro Tag pro 100 Quadratmeter angegeben, sobald die Daten geladen wurden.</div>',
    attachTo: {
      element: ".ol-layer",
      on: "left-end"
    },
    beforeShowPromise: function() {
      return new Promise(function(resolve) {
        if(store.state.selectedUpdate?.updateStatus === 'calculated'){
          resolve()
        } else {
          tour.next();
        }
      })
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: tour.back,
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-chevron-right"></i>',
        action: function () {
          tour.next();
        },
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  tour.addStep({
    id: "step-client",
    text:
      '<div class="sh-heading">Skala</div> <div class="sh-text">Die Höhe des Bedarf ist der Skala zu entnehmen.</div>',
    attachTo: {
      element: "#bar-container",
      on: "left"
    },
    beforeShowPromise: function() {
      return new Promise(function(resolve) {
        if(store.state.selectedUpdate?.updateStatus === 'calculated'){
          resolve()
        } else {
          tour.next();
        }
      })
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: tour.back,
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-chevron-right"></i>',
        action: function () {
          document.getElementById("auto-adjust-checkbox").click();
          tour.next();
        },
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  tour.addStep({
    id: "step-client",
    text:
      '<div class="sh-heading">Skala</div> <div class="sh-text">Um die verschiedenen Ergebnisse miteinander vergleich zu können, können die maximalen Bedarfswerte manuell angepasst und über die verschiedenen ausgewählten Jahre konstant gehalten werden.</div>',
    attachTo: {
      element: "#min-max-value-container",
      on: "left"
    },
    beforeShowPromise: function() {
      return new Promise(function(resolve) {
        if(store.state.selectedUpdate?.updateStatus === 'calculated'){
          resolve()
        } else {
          tour.next();
        }
      })
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: tour.back,
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-chevron-right"></i>',
        action: function () {
          document.getElementById("screenshot-btn").click();
          document.getElementById("auto-adjust-checkbox").click();

          setTimeout(() => {
            tour.next();
          }, 1);
        },
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  tour.addStep({
    id: "step-client",
    text:
      '<div class="sh-heading">Screenshot</div> <div class="sh-text">Von dem aktuellen Kartenausschnitt kann ein Screenshot im PDF-Format erstellt und heruntergeladen werden.</div>',
    attachTo: {
      element: "#bottom-controls-container",
      on: "left"
    },
    beforeShowPromise: function() {
      return new Promise(function(resolve) {
        if(store.state.selectedUpdate?.updateStatus === 'calculated'){
          resolve()
        } else {
          tour.next();
        }
      })
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: tour.back,
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-chevron-right"></i>',
        action: function () {
          document
            .getElementById("bf2396cd-04c2-448e-9481-a61b20e5b0ae")
            .click();
          setTimeout(() => {
            document.getElementById("punkte-btn").click();
            tour.next();
          }, 1);
        },
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  tour.addStep({
    id: "step-client",
    text:
      '<div class="sh-heading">Informationen zu einzelnen Koordinaten</div> <div class="sh-text">Sobald eine standortbasierte Ebene ausgewählt ist, können die zusätzlichen Informationen der einzelnen Koordinaten in einer Tabelle angezeigt werden. Die Tabelle kann als Excel- oder CSV-Datei exportiert werden.</div>',
    attachTo: {
      element: "#bottom-controls-container",
      on: "left"
    },
    beforeShowPromise: function() {
      return new Promise(function(resolve) {
        if(store.state.selectedUpdate?.updateStatus === 'calculated'){
          resolve()
        } else {
          tour.next();
        }
      })
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: tour.back,
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-chevron-right"></i>',
        action: function () {
          setTimeout(() => {
            document.getElementById("punkte-btn").click();
            tour.next();
          }, 1);
        },
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  // Update is not finished

  tour.addStep({
    id: "step-client",
    text:
      '<div class="sh-heading">Zur Berechnung freigeben</div> <div class="sh-text">Mithilfe dieses Buttons kann das erstellte Szenario zur Berechnung freigegeben werden. Die Parameter können dann erst für das nächste Szenario geändert bzw. angepasst werden. Bei Fertigstellung der Berechnung werden Sie über ihre hinterlegte E-Mail informiert.</div>',
    attachTo: {
      element: "#zur-berechnung-freigeben",
      on: "right"
    },
    beforeShowPromise: function() {
      return new Promise(function(resolve) {
        if(store.state.selectedUpdate?.updateStatus === 'editing'){
          resolve()
        } else {
          tour.next();
        }
      })
    },
    popperOptions: {
      modifiers: [{ name: "offset", options: { offset: [0, 12] } }]
    },
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: function () {
          console.log("back")
          if(store.state.selectedUpdate?.updateStatus === 'calculated'){
            tour.back();          
          } else {
            document.getElementById("berechnungsparameter-anpassen").click();
            tour.show("step-client-berechnungsparameter-dialog", true);
          }
        },
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-chevron-right"></i>',
        action: function () {
          tour.next();
        },
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });

  tour.addStep({
    id: "step-client",
    text:
      '<div class="sh-heading">Jetzt geht es Los</div> <div class="sh-text">Wir sind am Ende der Tour angelangt. Wir wünschen viel Spaß mit Quanticy.</div> <div class="sh-text" style="margin-top: 4px;"> Falls Sie die Tour nochmals machen wollen, klicken Sie einfach auf das Info-Icon rechts oben.</div>',
    buttons: [
      {
        text: '<i class="fas fa-chevron-left"></i>',
        action: tour.back,
        classes: "v-btn--icon"
      },
      {
        text: '<i class="fas fa-times"></i>',
        action: function () {
          tour.next();
        },
        classes: "v-btn--icon"
      }
    ],
    cancelIcon: {
      enabled: true
    }
  });
  
  tour.start();

  store.subscribe((mutation) => {
    if (mutation.type === 'berechnungsparameterAnpassen') {
      if(tour.isActive() && tour.getCurrentStep().options.id === 'step-client-berechnungsparameter-btn'){
        tour.next()
      }
    }
    if (mutation.type === 'nextStep') {
      if(tour.isActive()){
        setTimeout(() => {
          tour.next()
        }, 10)
      }
    }
  })

  return tour
}

export { shepherdTour }
